import $P from 'plugins/tfs/platformConfigs/integrationMaps/packageOrderDetail';
import $ST from 'plugins/tfs/platformConfigs/staticTextMaps/packageOrderDetail';

export const getFilterAttributes = () => {
  const filterKeys = $P.PACKAGE_ITEM.ORDER_ITEM.PRODUCT;
  const filterLabels = $ST.TABLE.COL;
  const filterExtraKeys = $P.PACKAGE_ITEM.PRINT_SETTINGS;

  return [
    {
      key: filterKeys.GENDER,
      label: filterLabels.GENDER,
      checked: true,
    },
    {
      key: filterExtraKeys.BRAND,
      label: filterLabels.BRAND,
      checked: true,
    },
    {
      key: filterExtraKeys.COLOR,
      label: filterLabels.COLOR,
      checked: true,
    },
    {
      key: filterKeys.SIZE,
      label: filterLabels.SIZE,
      checked: true,
    },
    {
      key: filterKeys.SKU,
      label: filterLabels.SKU,
      checked: true,
    },
    {
      key: filterKeys.EDI_BARCODE,
      label: filterLabels.EDI_BARCODE,
      checked: true,
    },
    {
      key: filterKeys.PRICE,
      label: filterLabels.PRICE,
      checked: true,
    },
    {
      key: $P.PACKAGE_ITEM.ORDER_ITEM.DISCOUNT_AMOUNT,
      label: filterLabels.DISCOUNT_PRICE,
      checked: true,
    },
    {
      key: filterKeys.SUPPLIER_MODEL_NUMBER,
      label: filterLabels.SUPPLIER_MODEL_NUMBER,
      checked: true,
    },
  ];
};



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/oms/PackageOrderList/printSettings/filters/index.js